/*! Lunburg system-packaging
 * Injects the complimentary EUR 0 "Signature Handmade Packaging" line into the
 * cart at the moment of checkout, then keeps it out of the cart UI during
 * normal browsing. The line rides into the Shopify checkout order summary as a
 * free line. Hidden everywhere else by the product's UNLISTED status.
 *
 * CONFIG: if the packaging product is ever recreated, update PKG below.
 *   Product:  gid://shopify/Product/10258449760585
 *   Variant:  gid://shopify/ProductVariant/54738562351433
 */
(function () {
  'use strict';
  var PKG = 54738562351433;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var checkingOut = false;

  function cartJSON() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(p, b) {
    return fetch(root + p, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: JSON.stringify(b)
    });
  }
  function onCartPage() {
    return !!(window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart');
  }

  // Add the packaging line right before checkout. Hard 1.5s timeout so a slow
  // network never blocks the buyer from checking out.
  function ensurePackaging() {
    return Promise.race([
      cartJSON().then(function (cart) {
        var items = (cart && cart.items) || [], pkg = null, real = 0;
        items.forEach(function (i) { if (i.variant_id === PKG) { pkg = i; } else { real += i.quantity; } });
        if (real > 0 && !pkg) return post('cart/add.js', { items: [{ id: PKG, quantity: 1 }] });
        if (pkg && pkg.quantity !== 1) return post('cart/change.js', { id: pkg.key, quantity: 1 });
        return null;
      }).catch(function () {}),
      new Promise(function (res) { setTimeout(res, 1500); })
    ]);
  }

  // Strip the packaging line out of the cart during normal browsing (e.g. after
  // the buyer returns to the cart from checkout). One guarded reload on the cart
  // page so the server-rendered row clears.
  function cleanupCartView() {
    if (checkingOut) return;
    cartJSON().then(function (cart) {
      var items = (cart && cart.items) || [], pkg = null;
      items.forEach(function (i) { if (i.variant_id === PKG) { pkg = i; } });
      if (!pkg) { sessionStorage.removeItem('lb_pkg_reload'); return; }
      post('cart/change.js', { id: pkg.key, quantity: 0 }).then(function () {
        if (onCartPage() && !sessionStorage.getItem('lb_pkg_reload')) {
          sessionStorage.setItem('lb_pkg_reload', '1');
          location.reload();
        } else {
          sessionStorage.removeItem('lb_pkg_reload');
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      });
    }).catch(function () {});
  }

  function submitCheckout(form, submitter) {
    try {
      if (submitter && typeof form.requestSubmit === 'function') { form.requestSubmit(submitter); return; }
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(); return; }
    } catch (e) {}
    if (submitter && submitter.name) {
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = submitter.name;
      hidden.value = submitter.value || '';
      form.appendChild(hidden);
    }
    form.submit();
  }

  // Intercept the cart / drawer checkout form submit.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || '').split('?')[0];
    if (!/\/cart$/.test(action)) return;
    var s = e.submitter;
    if (!s || !/checkout/i.test(s.getAttribute('name') || '')) return;
    if (form.__pkgPass) { form.__pkgPass = false; return; }
    e.preventDefault();
    checkingOut = true;
    ensurePackaging().then(function () { form.__pkgPass = true; submitCheckout(form, s); });
  }, true);

  // Intercept direct checkout links (drawers that use an <a href=".../checkout">).
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="/checkout"], a[href*="/checkout?"]');
    if (!a) return;
    if (a.__pkgPass) { a.__pkgPass = false; return; }
    e.preventDefault();
    checkingOut = true;
    ensurePackaging().then(function () { window.location.assign(a.href); });
  }, true);

  document.addEventListener('DOMContentLoaded', cleanupCartView);
  window.addEventListener('pageshow', function (e) { if (e && e.persisted) { cleanupCartView(); } });
})();
